import classnames from 'classnames/bind'
import { useRouter } from 'next/router'
import { ButtonHTMLAttributes } from 'react'

// Libs
import useActiveCategory from '../../../hooks/useActiveCategory'
import { useCategoryList } from '../../../hooks/useCategoryList'
import type { TabItemType } from '../../../utils/types'
import handleRoutePushWithQuery from '@/methods/url/handleRoutePushWithQuery'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

const TabItem = (props: Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className'> & { isActive?: boolean }) => {
  const { isActive, ...rest } = props
  return (
    <button
      {...rest}
      className={cx('search-categories-tab-item', {
        active: isActive,
      })}
    />
  )
}

const Tabs = () => {
  const router = useRouter()
  const activeTab = useActiveCategory()
  const SEARCH_CATEGORIES = useCategoryList()
  const handleTabClick = (value: TabItemType['value']) => {
    handleRoutePushWithQuery({
      router,
      pathname: router.pathname,
      query: {
        ...router.query,
        category: value,
      },
      isReplace: true,
    })
  }

  return (
    <div className={cx('tabs-wrapper')}>
      {SEARCH_CATEGORIES.map((tab) => (
        <TabItem key={tab.value} isActive={activeTab === tab.value} onClick={() => handleTabClick(tab.value)}>
          {tab.label}
        </TabItem>
      ))}
    </div>
  )
}

const CategoryTabs = () => {
  return (
    <div className={cx('search-categories')}>
      <Tabs />
    </div>
  )
}

export default CategoryTabs
